export type DoraLevel = 'elite' | 'high' | 'medium' | 'low';

export type TrendDirection = 'up' | 'down' | 'flat';

export function roundLeadTimeForDisplay(days: number): string {
  if (days < 1) {
    const hours = days * 24;
    if (hours < 0.1) return '<0.1h';
    return `${hours.toFixed(1)}h`;
  }
  return `${days.toFixed(1)}d`;
}

export function formatLeadTime(days: number, hasData: boolean): string {
  if (!hasData) return 'No data';
  return roundLeadTimeForDisplay(days);
}

export function formatCFR(value: number | null): string {
  if (value === null) return 'No data';
  return `${value.toFixed(1)}%`;
}

export function formatMTTR(hours: number | null): string {
  if (hours === null) return 'No data';
  if (hours < 1) return '< 1h';
  if (hours < 24) return `${hours.toFixed(1)}h`;
  return `${(hours / 24).toFixed(1)}d`;
}
